export const createPDPRedirectionUrl = (productId: string, productName: string): string => {
  const charsToRemove = /[<>#%{}|\\^~[\];/?:@=&`]/g;
  const formattedProductName = productName.replace(/\s+/g, '-');
  const filteredProductName = formattedProductName.replace(charsToRemove, '');
  return `/product/${filteredProductName}/${productId}`;
};
